<template>
  <div :class="style">
    <div>
      <!-- <img src="@/assets/icons/cook-head.svg"> -->
      <img :src="cartoonImage" :height="image.height" :width="image.width"/>
    </div>
    <RatingComponent v-if="showRating" class="col-3" :rating="1" />
  </div>
</template>
<script>
import RatingComponent from "@/components/generic/RatingComponent.vue";
export default {
  components: {
    RatingComponent
  },
  props: {
    image: Object,
    showRating: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: ""
    }
  },
  computed: {
    cartoonImage() {
      let image = this.image?.src || this.image?.url;
      if (image) {
        return image;
      }
      return image?.onerror;
    },
    style() {
      if (this.variant) {
        return "position-" + this.variant + "-" + this.$sizeType;
      }
      if (this.showRating) {
        return "position-with-rating";
      }
      return "position-default";
    }
  }
}
</script>
<style scoped>
.position-default {
  position: absolute;
  bottom: -20px;
  right: 20px;
}

.position-with-rating {
  position: absolute;
  bottom: -50px;
  right: 20px;
}

.position-cookheader-desktop {
  position: absolute;
  left: -60px;
  top: 50px;
}

.position-cookheader-tablet {
  position: absolute;
  bottom: -20px;
  right: 20px;
}

.position-cookheader-mobile {
  position: absolute;
  bottom: -20px;
  right: 20px;
}
</style>
